module.exports = __webpack_public_path__ + "media/stable/components/foundation/base/assets/polygon_badge-5095444819debdf34f07065395792581.svg";